<template>
    <div class="card-body">
        <h4 class="text-muted text-center">
            Tag
        </h4>


        <v-text-field :label="$t('message.generics.message.description')"
                      name="Descrição"
                      v-model="val.descricao"
                      v-validate="'required'"
                      :error-messages="errors.collect($t('message.generics.message.description'))"
                      @input="$emit('input', val)"></v-text-field>
    </div>
</template>

<script>
    import vModel from '@mixins/v-model'

    export default {
        components: {
        },

        data() {
            return {
            }
        },

        mounted() {
        },

        methods: {

            async validate() {
                await this.$validator.validateAll()

                if (this.$validator.errors.items.length !== 0)
                    return this.$emit('to-general-tab')

                this.$emit('valid')
            },

        },
        mixins: [vModel],

    }

</script>

<style lang="scss" scoped>
    @import "~@variables";

    .card-body {
        padding: 18px 50px 10px;

        .v-input {
            margin: 12px 0 10px 0;
        }


        .dates {
            display: flex;
            margin-bottom: 32px;

            .date {
                display: flex;
                flex-direction: column;
                align-items: center;
                flex: 1 0 auto;

                .datepicker-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 175px;
                    height: 55px;
                    padding: 0 15px;
                    border: $border-1;
                    border-radius: 4px;
                    font-weight: bold;
                    color: $grey-4;

                    .mdi {
                        font-size: 24px;
                    }

                    input {
                        color: $grey-4;
                    }
                }
            }
        }

        .segment {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            & > *:not(:first-child) {
                margin-top: 10px;
            }
        }
    }
</style>
